"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));
var _Remove = _interopRequireDefault(require("@material-ui/icons/Remove"));
var _VerticalSplit = _interopRequireDefault(require("@material-ui/icons/VerticalSplit"));
var _Fade = _interopRequireDefault(require("@material-ui/core/Fade"));
var _throttle = _interopRequireDefault(require("lodash/throttle"));
var _excluded = ["className", "disabled"],
  _excluded2 = ["showThumbnails", "onToggleThumbnails", "onZoomIn", "onZoomOut", "onZoomReset", "disabledZoomIn", "disabledZoomOut", "disabledZoomReset"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Button = function Button(_ref) {
  var className = _ref.className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({}, rest, {
    disabled: disabled,
    className: (0, _classnames["default"])('px-1 text-dark disabled:opacity-50 disabled:cursor-default font-semibold', {
      'hover:text-primary': !disabled
    }, className)
  }));
};
var _default = exports["default"] = function _default(_ref2) {
  var showThumbnails = _ref2.showThumbnails,
    onToggleThumbnails = _ref2.onToggleThumbnails,
    onZoomIn = _ref2.onZoomIn,
    onZoomOut = _ref2.onZoomOut,
    onZoomReset = _ref2.onZoomReset,
    _ref2$disabledZoomIn = _ref2.disabledZoomIn,
    disabledZoomIn = _ref2$disabledZoomIn === void 0 ? false : _ref2$disabledZoomIn,
    _ref2$disabledZoomOut = _ref2.disabledZoomOut,
    disabledZoomOut = _ref2$disabledZoomOut === void 0 ? false : _ref2$disabledZoomOut,
    _ref2$disabledZoomRes = _ref2.disabledZoomReset,
    disabledZoomReset = _ref2$disabledZoomRes === void 0 ? false : _ref2$disabledZoomRes,
    rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  var rootRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  (0, _react.useEffect)(function () {
    var timeout = null;
    var _rootRef$current$getB = rootRef.current.getBoundingClientRect(),
      top = _rootRef$current$getB.top,
      bottom = _rootRef$current$getB.bottom,
      left = _rootRef$current$getB.left,
      right = _rootRef$current$getB.right;
    var handleMouseMove = (0, _throttle["default"])(function (e) {
      setShow(true);
      clearTimeout(timeout);
      if (e.clientX >= left && e.clientX <= right && e.clientY >= top && e.clientY <= bottom) {
        return;
      }
      timeout = setTimeout(function () {
        setShow(false);
      }, 2000);
    }, 200);
    window.addEventListener('mousemove', handleMouseMove);
    return function () {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, rest, {
    className: "fixed bottom-0 mb-5",
    ref: rootRef,
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }), /*#__PURE__*/_react["default"].createElement(_Fade["default"], {
    "in": show
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center font-bold  shadow-lg bg-secondary select-none"
  }, !!onToggleThumbnails && /*#__PURE__*/_react["default"].createElement("div", {
    className: "border-r p-3"
  }, /*#__PURE__*/_react["default"].createElement(Button, {
    className: (0, _classnames["default"])({
      'text-primary': showThumbnails
    }),
    onClick: onToggleThumbnails
  }, /*#__PURE__*/_react["default"].createElement(_VerticalSplit["default"], null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-3"
  }, /*#__PURE__*/_react["default"].createElement(Button, {
    onClick: onZoomIn,
    disabled: disabledZoomIn
  }, /*#__PURE__*/_react["default"].createElement(_Add["default"], null)), /*#__PURE__*/_react["default"].createElement(Button, {
    onClick: onZoomOut,
    disabled: disabledZoomOut
  }, /*#__PURE__*/_react["default"].createElement(_Remove["default"], null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "border-l p-3"
  }, /*#__PURE__*/_react["default"].createElement(Button, {
    onClick: onZoomReset,
    disabled: disabledZoomReset
  }, "Reset")))));
};
//# sourceMappingURL=Controls.js.map